import { Component, HostListener, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common'
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatIconModule } from '@angular/material/icon';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatSelectModule } from '@angular/material/select';
import { MatRadioModule } from '@angular/material/radio';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { Router } from '@angular/router';
import { APIService } from '../../../fleet-management/backend-service/backend-service';
import { environment } from '../../../../environments/environment';
import { SharedService } from '../../../share-data/shared.service';
import { NotificationService } from '../../../shared/services/notification.service';
import { ConfirmationDialogService } from '../../../shared/services/confirmation-dialog.service';
import { LoadingService } from '../../../services/loading.service';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-report-predefind-data',
  imports: [
    ReactiveFormsModule,
    FormsModule,
    MatCheckboxModule,
    MatInputModule,
    CommonModule,
    MatChipsModule,
    MatSelectModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatIconModule,
    MatRadioModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './report-predefind-data.component.html',
  styleUrl: './report-predefind-data.component.scss'
})
export class ReportPredefindDataComponent implements OnDestroy {
  selectedDriverId: string | null = null;
  searchText: string = '';
  datas: any[] = [];
  currentPage: number = 1;
  totalPages: number = 1;
  pageSize: number = 10;
  pages: number[] = [];
  isLoading: boolean = false;
  private loadingSubscription: Subscription;

  constructor(private router: Router, private apiService: APIService, private sharedService: SharedService,
    private notification: NotificationService, private confirmationDialog: ConfirmationDialogService,
    public loadingService: LoadingService) {
    this.loadingSubscription = this.loadingService.isLoading$.subscribe(loading => this.isLoading = loading);
  }

  ngOnDestroy() {
    if (this.loadingSubscription) {
      this.loadingSubscription.unsubscribe();
    }
  }

  ngOnInit() {
    this.getReportList();
    // this.datas = [
    //   { expenseAccount: "CLEARANCE PROCESSING:CLEARANCE", expenseDesc: "CONTAINER SEAL", expenseAmount: "3", expenseClass: "CK25-029133", expenseLineClass: "CK25-029133", expenseBillableEntity: "VINALINK"},
    //   { expenseAccount: "CLEARANCE PROCESSING:CLEARANCE", expenseDesc: "CUSTOMS ACCOUNTING​​ RECEIPT", expenseAmount: "3", expenseClass: "SN25-019899", expenseLineClass: "SN25-019899", expenseBillableEntity: "MAERSK LOGISTICS & SERVICES (CAMBODIA) CO., LTD"},
    //   { expenseAccount: "CLEARANCE PROCESSING:CLEARANCE", expenseDesc: "EXPORT PERMIT​ DIRED COW SKIN", expenseAmount: "10", expenseClass: "SN25-019866", expenseLineClass: "SN25-019866", expenseBillableEntity: "CAMBODIAN NOBLE TASTE FOOD CO., LTD."},
    //   { expenseAccount: "CLEARANCE PROCESSING:CLEARANCE", expenseDesc: "DEPUTY CUSTOMS", expenseAmount: "5", expenseClass: "CK25-029216", expenseLineClass: "CK25-029216", expenseBillableEntity: "SEEHORN SUPPLY CHAIN MANAGMENT(CAMBODIA) CO., LTD"},
    //   { expenseAccount: "CLEARANCE PROCESSING:CLEARANCE", expenseDesc: "CUSTOMS INSPECTION", expenseAmount: "25", expenseClass: "SN25-019900", expenseLineClass: "SN25-019900", expenseBillableEntity: "APOLLO PET PRODUCTS (CAMBODIA) CO., LTD"},
    //   { expenseAccount: "CLEARANCE PROCESSING:CLEARANCE", expenseDesc: "CUSTOMS STAMP", expenseAmount: "4", expenseClass: "SN25-019765", expenseLineClass: "SN25-019765", expenseBillableEntity: "OOCL LOGISTICS (CAMBODIA) LIMITED"},
    //   { expenseAccount: "CLEARANCE PROCESSING:CLEARANCE", expenseDesc: "COLOR CUSTOMS", expenseAmount: "30", expenseClass: "SN25-019865", expenseLineClass: "SN25-019865", expenseBillableEntity: "WCS SERVICES CO., LTD"},
    //   { expenseAccount: "CLEARANCE PROCESSING:CLEARANCE", expenseDesc: "OTHER EXPENSES", expenseAmount: "15", expenseClass: "SN25-020171", expenseLineClass: "SN25-020171", expenseBillableEntity: "MASS-LOG (CAMBODIA) CO., LTD"},
    // ];
  }
  getReportList(page: number = 1) {
    this.datas = [];
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    console.log("LoginData: ", loginData)
    this.apiService.get(`/api/predefined-expenses`, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/predefined-expenses' + ',\n' + 'report_list_Response:', response.body);
        if (response.status === 200) {
          this.datas = response.body["predefinedExpenses"];
          this.totalPages = response.body.pagination.totalPages;
          this.pages = Array(this.totalPages).fill(0).map((_, i) => i + 1);
          this.currentPage = page;
        }
        else {
          console.log("Hey you")
        }
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }
  addNewReportData() {
    this.router.navigate(['/home/settings/report-predefind-data/report-predefind-add-new']);
  }
  get filteredOrders() {
    return this.datas.filter(data =>
      data.expenseAccount.toLowerCase().includes(this.searchText.toLowerCase()) ||
      data.expenseDesc.toLowerCase().includes(this.searchText.toLowerCase()) ||
      data.expenseClass.toLowerCase().includes(this.searchText.toLowerCase())
    );
  }
  onEditAction(data: any) {
    console.log("Selected Id: ", data.id)
    if (this.selectedDriverId === data.id) {
      this.selectedDriverId = null;
    } else {
      this.selectedDriverId = data.id;
    }
  }
  onEdit(data: any) {
    this.selectedDriverId = null;
    this.sharedService.setData(data);
    this.router.navigate(
      ['/home/settings/report-predefind-data/report-predefind-add-new/:id'],
      { queryParams: { isEdit: true } }
    );
  }
  onDelete(data: any) {
    this.selectedDriverId = null;
    this.confirmationDialog.confirmDelete(data.expenseDesc || 'this item').subscribe(confirmed => {
      if (confirmed) {
        this.deleteData(data);
      }
    });
  }
  deleteData(data: any) {
    let loginData = JSON.parse(localStorage.getItem('loginData')!)
    this.apiService.delete('/api/predefined-expenses/' + data.id, loginData.token).subscribe({
      next: (response) => {
        console.log('Status:', response.status);
        console.log('/api/drivers/delete' + ',\n' + 'Driver_Delete_Response:', response);
        this.notification.success(response.message || 'Operation completed successfully');
        this.getReportList();
      },
      error: (error) => {
        console.error('Error status:', error.status);
        console.error('Error message:', error.message);
      }
    });
  }
  @HostListener('document:click', ['$event'])
  handleClickOutside(event: MouseEvent) {
    const target = event.target as HTMLElement;

    // Only close the dropdown if clicked outside any dropdown-related button or menu
    if (!target.closest('.action-btn') && !target.closest('.action-menu')) {
      this.selectedDriverId = null;
    }
  }
}
